import {
  Dashboard as DashboardIcon,
  Group as GroupIcon,
  Person as PersonIcon,
  EventNote as EventNoteIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  ManageAccounts as ManageAccountsIcon,
  SupervisorAccount as SupervisorAccountIcon,
  BarChart as BarChartIcon,
  VpnKey as VpnKeyIcon,
  ExitToApp as ExitToAppIcon,
  LocalAirport as LocalAirportIcon,
  Notifications as NotificationsIcon,
  LocalOffer,
} from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BuildIcon from "@mui/icons-material/Build";
import {
  AIRPORTS,
  BOOKINGS,
  CHANGE_PASSWORD,
  CUSTOMERS,
  DASHBOARD,
  INVOICES,
  NOTIFICATIONS,
  PROFILE_UPDATE,
  REPORTS,
  ROLES,
  STAFFS,
  VENDORS,
  SERVICES,
  GROUP_BOOKINGS,
  PROMOCODE,
  ANNOUNCEMENTS,
} from "../Routes/AppRoutes";
export const adminMenuItems = [
  {
    text: "Dashboard",
    icon: <DashboardIcon sx={{ color: "#3F51B5" }} />,
    path: DASHBOARD,
  },
  {
    text: "Vendors",
    icon: <GroupIcon sx={{ color: "#4CAF50" }} />,
    path: VENDORS,
  },
  {
    text: "Customers",
    icon: <PersonIcon sx={{ color: "#2196F3" }} />,
    path: CUSTOMERS,
  },
  {
    text: "Bookings",
    icon: <EventNoteIcon sx={{ color: "#FF9800" }} />,
    path: BOOKINGS,
  },
  //   {
  //   text: "GroupBooking",
  //   icon: <EventNoteIcon sx={{ color: "#FF9800" }} />,
  //   path: GROUP_BOOKINGS
  // },
  {
    text: "Services",
    icon: <BuildIcon sx={{ color: "#0288D1" }} />,
    path: SERVICES,
  },
  {
    text: "Airports",
    icon: <LocalAirportIcon sx={{ color: "#4CAF50" }} />,
    path: AIRPORTS,
  },

  {
    text: "Invoices",
    icon: <AccountBalanceWalletIcon sx={{ color: "#D32F2F" }} />,
    path: INVOICES,
  },
  {
    text: "Roles",
    icon: <ManageAccountsIcon sx={{ color: "#673AB7" }} />,
    path: ROLES,
  },
  {
    text: "Staffs",
    icon: <SupervisorAccountIcon sx={{ color: "#4CAF50" }} />,
    path: STAFFS,
  },
  {
    text: "Reports",
    icon: <BarChartIcon sx={{ color: "#F57C00" }} />,
    path: REPORTS,
  },
  {
    path: NOTIFICATIONS,
    text: "Notifications",
    icon: <NotificationsIcon />,
  },
  {
    path: PROMOCODE,
    text: "Promo Code",
    icon: <LocalOffer />,
  },
  // {
  //   path: ANNOUNCEMENTS,
  //   text: "Announcements",
  //   icon: <NotificationsIcon />,
  // },
  {
    text: "Profile",
    icon: <AccountCircleIcon sx={{ color: "#2196F3" }} />,
    path: PROFILE_UPDATE,
  },
  {
    text: "Change Password",
    icon: <VpnKeyIcon sx={{ color: "#009688" }} />,
    path: CHANGE_PASSWORD,
  },
  {
    text: "Logout",
    icon: <ExitToAppIcon sx={{ color: "#CC0033" }} />,
    action: "logout",
  },
];
